module.exports = __webpack_public_path__ + "static/img/05.b18a3667.jpg";